/**
 * Retrieves the value of a preference property from the given preferences.
 *
 * @template T - The type of the preference property value.
 * @param preferences - The hauler preferences or an array of hauler preference transports.
 * @param property - The key of the preference property to retrieve.
 * @returns The value of the preference property, or null if it doesn't exist.
 */
export function getPreferenceProperty(preferences, property) {
    if (!preferences)
        return null;
    const preference = preferences.find((pref) => pref.key === property);
    if (!preference) {
        return null;
    }
    else {
        // @ts-expect-error - This is a valid type.
        return preference.value.value;
    }
}
//# sourceMappingURL=extract-preference-property.js.map